export default __webpack_public_path__ + "media/Hero_Tablet.fe07c299f4b7ec7ba07853b76580b6e9.svg";